<template>
  <div class="seniority-selector">
    <ue-select
      :options="seniorities"
      @input="selected"
      v-model="seniority"
      placeholder="Select Seniority"
    />
  </div>
</template>
<script lang="ts">
export default {
  props: ['input', 'value'],
  data() {
    return {
      seniority: null,
      seniorities: [
        { code: 'executive', label: 'VP/C-level/Business Owner' },
        { code: 'manager', label: 'Director level/manager level' },
        { code: 'individual_contriubutor', label: 'Individual Contributor/Specialist/Associate' },
      ],
    }
  },
  mounted() {
    this.seniority = this.seniorities.filter((s) => s.code == this.value)
  },
  methods: {
    selected() {
      this.$emit('input', this.seniority.code)
    },
  },
}
</script>
<style lang="sass" scoped></style>
